import { render, staticRenderFns } from "./VuesticKycSelect.vue?vue&type=template&id=3ce2e49e"
import script from "./VuesticKycSelect.vue?vue&type=script&lang=js"
export * from "./VuesticKycSelect.vue?vue&type=script&lang=js"
import style0 from "./VuesticKycSelect.vue?vue&type=style&index=0&id=3ce2e49e&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce2e49e')) {
      api.createRecord('3ce2e49e', component.options)
    } else {
      api.reload('3ce2e49e', component.options)
    }
    module.hot.accept("./VuesticKycSelect.vue?vue&type=template&id=3ce2e49e", function () {
      api.rerender('3ce2e49e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-simple-select-kyc/VuesticKycSelect.vue"
export default component.exports